import React, { useEffect, useState } from 'react';
import { Table, Space, Tooltip, Modal, message } from 'antd';
import { EditOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../../../firebase-config';
import FormBatch from '../FormBatch/FormBatch';
import ButtonComponent from '../../../CssComponents/ButtonComponent/ButtonComponent';
import styles from '../../../../styles/LmsList.module.css';
import arLogo from "../../../../logo.webp"

function ListBatch() {
    const [batches, setbatches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [initialValues, setInitialValues] = useState({});

    useEffect(() => {
        const fetchbatches = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, 'lms_batch'));
                const data = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setbatches(data);
            } catch (error) {
                console.error('Error fetching batches:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchbatches();
    }, []);

    const handleCreateBatch = () => {
        setInitialValues({});
        setShowForm(true);
    };

    const handleEditBatch = (batch) => {
        setInitialValues(batch);
        setShowForm(true);
    };

    const handleDeleteBatch = async (batchId) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this batch?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    await deleteDoc(doc(db, 'lms_batch', batchId));
                    message.success('Batch deleted successfully');
                    setbatches(prev => prev.filter(b => b.id !== batchId));
                } catch (error) {
                    console.error('Error deleting batch:', error);
                    message.error('Failed to delete batch: ' + error.message);
                }
            },
        });
    };

    const columns = [
        {
            title: 'Banner',
            dataIndex: 'batchBanner',
            key: 'batchBanner',
            render: url => (
                <img
                    src={url || arLogo}
                    alt="Batch Banner"
                    style={{ width: 60, height: 40, objectFit: 'cover', borderRadius: 4 }}
                />
            ),
        },
        {
            title: 'Batch Name',
            dataIndex: 'batchName',
            key: 'batchName',
            render: text => text || 'Untitled Batch',
        },
        {
            title: 'Description',
            dataIndex: 'batchDescription',
            key: 'batchDescription',
            render: text => text || 'No description available.',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <EditOutlined
                            onClick={() => handleEditBatch(record)}
                        />
                    </Tooltip>
                    <Tooltip title="View">
                        <EyeOutlined
                            onClick={() => handleEditBatch(record)}
                        />
                    </Tooltip>
                    <Tooltip title="Delete">
                        <DeleteOutlined
                            onClick={() => handleDeleteBatch(record.id)}
                            style={{ color: 'red' }}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    return (
        <div className={styles.container}>

            <div className={styles.header}>
                <div className={styles.heading}>Available batches</div>
                <ButtonComponent
                    onClick={handleCreateBatch}
                    buttonText={"Create New Batch"}
                />
            </div>

            <Table
                dataSource={batches}
                columns={columns}
                rowKey="id"
                loading={loading}
                pagination={{ pageSize: 8 }}
            />

            {showForm && (
                <FormBatch
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    showForm={showForm}
                    onClose={() => setShowForm(false)}
                />
            )}
        </div>
    );
}

export default ListBatch;
